import { render, staticRenderFns } from "./SiteMapBody.vue?vue&type=template&id=977ffc0e&scoped=true"
import script from "./SiteMapBody.js?vue&type=script&lang=js&external"
export * from "./SiteMapBody.js?vue&type=script&lang=js&external"
import style0 from "./SiteMapBody.scss?vue&type=style&index=0&id=977ffc0e&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "977ffc0e",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HotLink: require('/runner/_work/app-hotmart/app-hotmart/components/Atoms/Link/Link.vue').default})
